import React from "react";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { HashLink } from "react-router-hash-link";

const Header = () => {
  const { user, logOut } = useAuth();

  // const { user, logout } = useFirebase;
  return (
    <>
      <Navbar
        sticky="top"
        bg="dark"
        variant="dark"
        collapseOnSelect
        expand="lg"
      >
        <Container>
          <Navbar.Brand href="#home">MediLife</Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Nav.Link as={HashLink} to="/home#home">
              Home
            </Nav.Link>
            <Nav.Link as={HashLink} to="/home#Services">
              Services
            </Nav.Link>
            <Nav.Link as={HashLink} to="/home#fetures">
              Features
            </Nav.Link>
            <Nav.Link as={HashLink} to="/home#about">
              About
            </Nav.Link>
            {user?.email ? (
              <Button onClick={logOut} variant="danger">
                Logout
              </Button>
            ) : (
              <Nav.Link as={Link} to="/login">
                Login
              </Nav.Link>
            )}

            {/* {user?.auth && (
              <span style={{ color: "whitesmoke" }}>
                Hellow {user.displayName} <br />
              </span>
            )}

            {user?.auth ? (
              <button onClick={logout}> Log Out </button>
            ) : (
              <NavLink as={Link} to="/login">
                Login
              </NavLink>
            )} */}

            <Navbar.Text>
              <a href="#login">{user?.displayName}</a>
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
